import React from "react";
// import FastTextArea from "components/FormElements/FastTextArea";
import CodeEditor from "@uiw/react-textarea-code-editor";
import { Field, useField } from "formik";

function EditortextMetaProperty(props) {
    const [field] = useField(props);

    return (
        <Field name={field.name}>
            {({ field }) => (
                <div className="rounded-md border border-gray-300 bg-white p-3 shadow-sm">
                    <CodeEditor
                        value={field.value || ""}
                        onChange={field.onChange(field.name)}
                        language={
                            props.codeLanguage ? props.codeLanguage : "html"
                        }
                        padding={2}
                        style={{
                            borderLeft: "6px solid #f1f1f1",
                            fontSize: 12,
                            backgroundColor: "#ffffff",
                            fontFamily:
                                "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                        }}
                    />
                </div>
            )}
        </Field>
    );
}

export default EditortextMetaProperty;

export const Property = EditortextMetaProperty;

export const Label = "Editor Text";
